// Single import point for Leaflet and its plugins.
//
// leaflet.markercluster's UMD build does not require('leaflet'); it reads the
// global `L`. Under webpack nothing is global, so the plugin must be evaluated
// AFTER `window.L` exists -- hence the require() below an import, which is the
// one ordering ES module hoisting cannot reorder.
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

if (typeof window !== 'undefined' && !window.L) window.L = L
require('leaflet.markercluster')

export default L
